import { render, staticRenderFns } from "./DocsTechStack.vue?vue&type=template&id=1060b4d0&scoped=true&"
import script from "./DocsTechStack.vue?vue&type=script&lang=js&"
export * from "./DocsTechStack.vue?vue&type=script&lang=js&"
import style0 from "./DocsTechStack.vue?vue&type=style&index=0&id=1060b4d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1060b4d0",
  null
  
)

export default component.exports